module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-kpito-intro-card1.2.eddb9262.jpg";